function trigger(eventTarget: EventTarget, type: string, config: CustomEventInit = {}): boolean {
    const defaultConfig: CustomEventInit = {
        bubbles: false,
        cancelable: true,
    };

    const customEvent = new CustomEvent(type, {
        ...defaultConfig,
        ...config,
    });

    return eventTarget.dispatchEvent(customEvent);
}

// ----------------------------------------------------------------------------

export default trigger;
